import React, { useEffect, useContext, useState } from 'react'
import { Link } from "react-router-dom";

import { DefaultContext } from '../../context/context_default';

import ItemListDeck from './componente/itemListDeck';
import ItemListDeckBuild from "../deckBuild/componente/itemList"
import GraficoBarras from "../deckBuild/componente/grafico_barras"
import ModalConfirm from '../../componentes/modal_confirm';

import imgBG from "../../assets/imagens/bg_decklist.jpg";
import imgPrimura from "../../assets/imagens/primura-face-60.png";
import imgEnneda from "../../assets/imagens/enneda-face-80.png";

import AddRoundedIcon from '@mui/icons-material/AddRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';

import { useDeckList } from './hook';

const DeckList = () => {
	const {
		listDecksUser,
		deckSelect,
		setDeckSelect,
		changeDeck,
		isOpenDeck,
		toggleDrawerDeck,
		estiloCard,
		loadMoreDecks,
		hasMore,
		loading,
		isOpenDeleteModal,
		deckToDelete,
		openDeleteModal,
		closeDeleteModal,
		deleteDeck
	} = useDeckList();
	const {
		globalFirestoreData,
		listCardDeck,
		listCards,
		showListCards,
		showCardFlutuante,
		is_descktop,
		setDeck_tu_edit,
		conta_cartas_lsit,
		setShowCardFlutuante,
		share_deck,
		tipos,
		subTipos,
		palavraChave
	} = useContext(DefaultContext);
	const divider = () => { return (<div className='flex-1 border-b border-slate-600 h-0'></div>) }

	const estiloDoComponente = {
		WebkitFilter: 'drop-shadow(0px 0px 4px #0f0f0f)',
		filter: 'drop-shadow(0px 0px 4px #0f0f0f)',
	};

	const estiloDoComponenteImg = {
		WebkitFilter: 'drop-shadow(0px 0px 2px #000000)',
		filter: 'drop-shadow(0px 0px 2px #000000)',
	};

	const handleNavigateExternal = (id) => {
		const currentURL = window.location.href;
		window.open(currentURL.split("/")[0] + "/detail/" + id, '_blank');
	};
	useEffect(() => {
		if (!isOpenDeck) {
			setShowCardFlutuante(false);
		}
	}, [isOpenDeck])

	return (

		<div style={{ backgroundImage: `url(${imgBG})`, }} className='h-full w-full bg-cover bg-center flex justify-center md:justify-end items-cente overflow-hidden'>
			<div className={`${isOpenDeck ? 'md:mr-[320px] duration-200' : 'mr-0 duration-200'} bg-slate-700 bg-opacity-[94%] w-full h-full pt-16 transition-all  `}>
				{

					globalFirestoreData.userId ?
						<>
							<div className='bg-gradient-to-b from-transparent via-transparent to-slate-900 w-full h-full p-4 overflow-y-auto  scrollbar-thin scrollbar-thumb-slate-600  scrollbar-rounded-sm  '>
								<div className='mb-6'>
									<h2 className='text-3xl font-bold text-white mb-2'>Seus Decks</h2>
									<p className='text-slate-300 text-base leading-relaxed max-w-4xl'>Crie listas de cartas incríveis e compartilhe com a comunidade ou planeje uma mega estratégia e deixe privado para que ninguém roube a sua maravilhosa ideia!</p>
								</div>
								<div className='flex flex-wrap gap-4 justify-start'>

									{showCardFlutuante?.card ? <div className={`${showCardFlutuante && is_descktop ? "" : "hidden"} w-40 h-auto    right-80 mr-2 absolute z-40`} style={estiloCard}>
										{/* <img className=' w-full h-full object-contain' style={estiloDoComponente} src={showCardFlutuante?.url_img} loading="lazy" ></img> */}
										<div className={`bg-slate-800 text-white shadow-md border-l-4 border-blue-500`}>
											<div className='p-2 pb-0'>{showCardFlutuante.card?.nome}</div>
											<div className='p-2 pt-0 text-xs'>{showCardFlutuante.card?.tipo?.map(e => tipos?.find(t => t.id == e)?.tipo + ' ')} / {showCardFlutuante.card?.sub_tipo?.map(e => subTipos?.find(t => t.id == e)?.tipo + ' ')}</div>

											{showCardFlutuante.card.custo || showCardFlutuante.card.poder || showCardFlutuante.card.vida ? <div className='border-b border-slate-700 '></div> : null}
											{showCardFlutuante.cardcusto ? <div className='p-2 pb-1 pt-1 flex justify-between items-center text-xs'><div>Custo:</div><div className='border-b border-slate-500 border-opacity-25 w-full mx-3'></div><div>{showCardFlutuante.card.custo}</div>  </div> : null}
											{showCardFlutuante.card.p_a ? <div className='p-2 pb-0 pt-0 flex justify-between items-center text-xs'><div>Poder:</div><div className='border-b border-slate-500 border-opacity-25 w-full mx-3'></div><div>{showCardFlutuante.card.p_a}</div> </div> : null}
											{showCardFlutuante.card.vida ? <div className='p-2 pb-1 pt-1 flex justify-between items-center text-xs'><div>Vida:</div><div className='border-b border-slate-500 border-opacity-25 w-full mx-3'></div><div>{showCardFlutuante.card.vida}</div> </div> : null}


											{showCardFlutuante.card.p_c.length > 0 ? <div className='border-b border-slate-700 '></div> : null}
											{showCardFlutuante.card.p_c.length > 0 ? <div className='p-2 pb-1 pt-1 text-xs'>Palavras chave</div> : null}
											{palavraChave && showCardFlutuante.card ? showCardFlutuante.card?.p_c?.map(id => { return <div className='p-2 pb-0 pt-0 text-xs flex justify-start items-center'><div className='rounded-full w-1 h-1 bg-slate-300 mr-2 ml-2 '></div><div>{palavraChave?.find(item => item.id == id)?.nome} </div></div> }) : null}
											{showCardFlutuante.card.p_c.length > 0 ? <div className='p-2 pb-1 pt-1 text-xs'></div> : null}
										</div>
									</div> : null}

									<Link to='/deck-build' className='flex-none w-44 h-56 sm:w-48 sm:h-60 md:w-52 md:h-64 bg-slate-600 border border-slate-700 rounded-2xl shadow hover:bg-slate-500 cursor-pointer p-1 transition-colors duration-200'>
										<div className='flex flex-col justify-center items-center w-full h-full border rounded-xl border-slate-400 border-opacity-50'>
											<AddRoundedIcon className="text-slate-300 scale-[2] mb-2"></AddRoundedIcon>
											<span className='text-slate-300 text-sm font-medium'>Novo Deck</span>
										</div>
									</Link>

									{listDecksUser ? listDecksUser.map((item, index) => { return <div key={index} className='flex-none w-44 h-56 sm:w-48 sm:h-60 md:w-52 md:h-64' onClick={() => { toggleDrawerDeck(true); changeDeck(item) }}><ItemListDeck deck={item} onDelete={openDeleteModal}></ItemListDeck> </div> }) : null}
								</div>

								{/* Botão Carregar Mais */}
								{/* {listDecksUser && hasMore && (
									<div className='w-full flex justify-center mt-8 mb-4'>
										<button
											onClick={loadMoreDecks}
											disabled={loading}
											className={`px-8 py-3 rounded-lg font-medium transition-all duration-200 ${loading
												? 'bg-slate-600 text-slate-400 cursor-not-allowed'
												: 'bg-blue-600 hover:bg-blue-500 text-white cursor-pointer shadow-lg hover:shadow-xl'
												}`}
										>
											{loading ? 'Carregando...' : 'Carregar Mais Decks'}
										</button>
									</div>
								)} */}

								{/* Indicador de fim da lista */}
								{listDecksUser && !hasMore && listDecksUser.length > 0 && (
									<div className='w-full flex justify-center mt-8 mb-4'>
										<span className='text-slate-400 text-sm'>Todos os decks foram carregados</span>
									</div>
								)}

								{/* Mensagem quando não há decks */}
								{listDecksUser && listDecksUser.length === 0 && (
									<div className='w-full flex flex-col items-center justify-center mt-12 mb-8'>
										<div className='text-slate-400 text-lg mb-2'>Nenhum deck encontrado</div>
										<div className='text-slate-500 text-sm'>Crie seu primeiro deck clicando no botão acima!</div>
									</div>
								)}
							</div>
							<aside className={`${isOpenDeck ? 'translate-x-0 duration-200' : ' duration-300 translate-x-full '} overflow-x-visible bg-slate-700  pt-16 transition-transform  fixed top-0 right-0 z-30 w-80 h-screen shadow-lg flex flex-col p-3 border-l border-slate-600 border-opacity-60`}>

								{deckSelect ?
									<div className='flex flex-col justify-start overflow-y-auto  scrollbar-thin overflow-x-hidden scrollbar-thumb-slate-600  scrollbar-rounded-sm pr-2 h-full pt-4'>
										<div className='flex justify-between w-full mb-4'>
											<div className='flex items-center '  >


												<span className='cursor-pointer font-bold'>{deckSelect.nome}</span>



											</div>

											<div className='rounded-full w-7 h-7 flex justify-center items-center bg-slate-600 hover:bg-opacity-75 cursor-pointer' onClick={() => { toggleDrawerDeck(false) }}><CloseRoundedIcon></CloseRoundedIcon>
											</div>

										</div>

										<div className='text-xs'>{deckSelect?.share || deckSelect?.share == null ? "Deck Público" : 'Deck Privado'}</div>

										<div className='flex items-center justify-around space-x-3 my-4 rounded-lg border border-slate-600 border-opacity-50 bg-gradient-to-r from-slate-800 to-slate-700 bg-opacity-70 p-4 shadow-lg'>
											<div className='text-2xl text-slate-200 flex flex-col items-center'>
												<div className='text-xs font-medium text-slate-400 mb-1'>Árvore</div>
												<div className='font-bold text-blue-400'>
													{conta_cartas_lsit(deckSelect.arvore)}/
													{conta_cartas_lsit(deckSelect.arvore) > 40 ? '50' : conta_cartas_lsit(deckSelect.arvore) > 30 ? '40' : '30'}
												</div>
											</div>
											<div className='w-px h-8 bg-slate-600'></div>
											<div className='text-2xl text-slate-200 flex flex-col items-center'>
												<div className='text-xs font-medium text-slate-400 mb-1'>Matriz</div>
												<div className='font-bold text-purple-400'>
													{conta_cartas_lsit(deckSelect.matriz)}/
													{conta_cartas_lsit(deckSelect.matriz) > 40 ? '50' : conta_cartas_lsit(deckSelect.matriz) > 30 ? '40' : '30'}
												</div>
											</div>

										</div>
										<div className='flex items-center space-x-3 my-4 mt-6'>
											<span className='text-xs font-semibold text-slate-300 bg-slate-600 bg-opacity-50 px-2 py-1 rounded'>QUEBRADOR</span>
											{divider()}
										</div>


										<div>
											{deckSelect.quebrador ? <ItemListDeckBuild item={{ id: deckSelect.quebrador }} lessItem={() => { handleNavigateExternal(deckSelect.quebrador) }} addItem={() => { }} className='overflow-x-visible' > </ItemListDeckBuild> : null}
										</div>



										<div className='flex items-center space-x-3 my-4 mt-6'>
											<span className='text-xs font-semibold text-slate-300 bg-blue-600 bg-opacity-30 px-2 py-1 rounded'>ÁRVORE</span>
											{divider()}
										</div>
										<GraficoBarras listCardDeck={deckSelect.arvore}></GraficoBarras>

										<div className="flex flex-col justify-center items-center w-full mt-5">
											<div className="border border-dashed border-gray-500 rounded-md w-full min-h-[200px] max-h-[400px] overflow-y-auto scrollbar-thin scrollbar-thumb-slate-600 scrollbar-rounded-sm p-1">
												<div className="h-auto">
													{deckSelect.arvore.map((item, index) => (
														<ItemListDeckBuild
															key={index}
															item={item}
															lessItem={() => { handleNavigateExternal(item.id) }}
															addItem={() => { }}
															className="overflow-x-visible"
														/>
													))}
												</div>
											</div>
										</div>

										<div className='flex items-center space-x-3 my-4 mt-6'>
											<span className='text-xs font-semibold text-slate-300 bg-purple-600 bg-opacity-30 px-2 py-1 rounded'>MATRIZ</span>
											{divider()}
										</div>

										{/* <GraficoBarras></GraficoBarras> */}

										<div className="flex flex-col justify-center items-center w-full mt-5">
											<div className="border border-dashed border-gray-500 rounded-md w-full min-h-[200px] max-h-[400px] overflow-y-auto scrollbar-thin scrollbar-thumb-slate-600 scrollbar-rounded-sm p-1">
												<div className="h-auto">
													{deckSelect.matriz.map((item, index) => (
														<ItemListDeckBuild
															key={index}
															item={item}
															lessItem={() => { handleNavigateExternal(item.id) }}
															addItem={() => { }}
															className="overflow-x-visible"
														/>
													))}
												</div>
											</div>
										</div>
										<div className='flex justify-end items-center mt-6 mb-4 space-x-2'>


											<Link to={`/deck/${deckSelect.id}`} className='bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 cursor-pointer rounded-lg px-4 py-2 flex items-center space-x-2 text-white transition-all duration-200 transform hover:scale-105 shadow-lg hover:shadow-xl border border-blue-500 border-opacity-30'>
												<VisibilityIcon className='text-sm' />
												<span className='font-medium'>Ver Detalhes</span>
											</Link>

											<Link to='/edita-deck' onClick={() => { setDeck_tu_edit(deckSelect) }} className='bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700 cursor-pointer rounded-lg px-4 py-2 flex items-center space-x-2 text-white transition-all duration-200 transform hover:scale-105 shadow-lg hover:shadow-xl border border-blue-500 border-opacity-30'>
												<EditIcon className='text-sm' />
												<span className='font-medium'>Editar</span>
											</Link>
											{/* <div className='flex justify-end  select-none '>
												<Link to='/edita-deck' onClick={() => { setDeck_tu_edit(deckSelect) }} className={`bg-orange-500 hover:bg-orange-400 cursor-pointer  rounded-md px-4 py-2`}  ></Link>
											</div> */}


										</div>
										<div className='flex justify-end items-center  mb-4 space-x-2'>
											<button
												onClick={() => openDeleteModal(deckSelect)}
												className='bg-red-600 hover:bg-red-700 cursor-pointer rounded-lg px-4 py-2 flex items-center space-x-2 text-white transition-all duration-200 transform hover:scale-105 shadow-lg hover:shadow-xl border border-red-500 border-opacity-30'
											>
												<DeleteIcon className='text-sm' />
												<span className='font-medium'>Excluir</span>
											</button>
										</div>

										{/* <div className='flex justify-end mt-4 select-none'>
                                    <div className={`${load ? "bg-orange-300" : "bg-orange-500"} hover:bg-orange-400 cursor-pointer  rounded-md px-4 py-2`} onClick={() => { salveDeck() }} disable={load} >Salvar</div>
                                </div> */}


									</div> : null}
							</aside>
						</>
						:
						<div className='h-full flex flex-col justify-center items-center relative  bg-gradient-to-b from-transparent via-transparent to-slate-900'>
							<div className='flex items-end justify-between w-full h-full absolute mb-[-3px]'>
								{/* <img style={estiloDoComponenteImg} className='md:h-[100%]  h-[390px] mb-[-80px] ml-[calc(-50vh_+_10vw)]' src={imgPrimura}></img>
                            <img style={estiloDoComponenteImg} className='md:h-[100%] h-[390px] mb-[-50px] mr-[calc(-60vh_+_10vw)]' src={imgEnneda}></img> */}
							</div>


							<div style={{ textShadow: '0px 0px 3px rgba(0, 0, 0, 1)' }} className='text-3xl font-bold text-center z-10 '>Desbloqueie o poder do criador de decks! </div>
							<div style={{ textShadow: '0px 0px 3px rgba(0, 0, 0, 1)' }} className='text-2xl font-bold text-center z-10'> Faça login agora para começar.</div>
							<div className='flex justify-end mt-4 select-none mb-6 z-10'>
								<Link to='/login' className={`bg-orange-500 hover:bg-orange-400 cursor-pointer  rounded-md px-4 py-2 z-10`}  >Login</Link>
							</div>
						</div>

				}

			</div>

			{/* Modal de confirmação de exclusão */}
			<ModalConfirm
				visible={isOpenDeleteModal}
				onClose={closeDeleteModal}
				onConfirm={deleteDeck}
				title="Confirmar Exclusão"
				msm={`Tem certeza que deseja excluir o deck "${deckToDelete?.nome}"? Esta ação não pode ser desfeita.`}
			/>

		</div>


	)
}

export default DeckList